






















import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';

@Component
export default class BannerGrid extends Vue {
  @Prop({ default: [], type: Array })banners!: string[];

  @Prop({ required: true, type: String })path!: string;

  @Prop({ type: Number, default: 5 })grid!: number;

  selectedItem: string = '';

  @Emit('on-item-click')
  onItemClick(game: string): void {
    this.selectedItem = game;
  }
}
